// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"b4d9162534020b81","491":"4aa7a600fe3c16ee"}[chunkId] + ".css";
};